/* DO NOT EDIT: this file was automatically generated by airtable-ts-codegen */
/* eslint-disable */
import type { Item, Table } from 'airtable-ts';

export interface Brand extends Item {
  id: string,
  name: string,
  status: string,
  campaigns: string[],
  logo: string,
  recordId: string | null,
}

export const brandsTable: Table<Brand> = {
  name: 'brands',
  baseId: 'apppFOPB68W0tWFuu',
  tableId: 'tblGh9Wrin8uLIzKU',
  mappings: {
    name: 'fld8pp7x4s6n0wdkU',
    status: 'fldrXKr2M524fUlai',
    campaigns: 'fldQxM85RKMTPliIR',
    logo: 'fldehb8tTHmYkaB4g',
    recordId: 'fldxjoWIAL8XCXeVr',
  },
  schema: {
    name: 'string',
    status: 'string',
    campaigns: 'string[]',
    logo: 'string',
    recordId: 'string | null',
  },
};

export interface Campaign extends Item {
  id: string,
  key: string | null,
  name: string,
  description: string,
  startDate: number,
  endDate: number,
  updatedAt: number,
  status: string,
  brand: string[],
  recordId: string | null,
  campaignTemplates: string[],
  campaignVariables: string[],
}

export const campaignsTable: Table<Campaign> = {
  name: 'campaigns',
  baseId: 'apppFOPB68W0tWFuu',
  tableId: 'tblvD16pwS1z8ncwo',
  mappings: {
    key: 'fldXzKMEBq5SHSNJS',
    name: 'fldoKgapMfonGmFEx',
    description: 'fldQP8AKe01NpFg6a',
    startDate: 'fldNFvv9aEfjdxmWj',
    endDate: 'fld7srdC9e5Fxa4nY',
    updatedAt: 'fldz6MbmnJksVzHYL',
    status: 'fldWRNrK3R5WTzh8L',
    brand: 'fldaGnnL97FBmlQnv',
    recordId: 'fldQnAYUHWYKqYk7E',
    campaignTemplates: 'fldKXLX9UDzcsQ8rr',
    campaignVariables: 'fld46R4agqUDErXAg',
  },
  schema: {
    key: 'string | null',
    name: 'string',
    description: 'string',
    startDate: 'number',
    endDate: 'number',
    updatedAt: 'number',
    status: 'string',
    brand: 'string[]',
    recordId: 'string | null',
    campaignTemplates: 'string[]',
    campaignVariables: 'string[]',
  },
};

export interface CampaignTemplate extends Item {
  id: string,
  recordId: string | null,
  name: string,
  templates: string[],
  campaign: string[],
  campaignTemplateVariables: string[],
}

export const campaignTemplatesTable: Table<CampaignTemplate> = {
  name: 'campaign_templates',
  baseId: 'apppFOPB68W0tWFuu',
  tableId: 'tblqEmLMInEXzeIMw',
  mappings: {
    recordId: 'fldRFzvX20XkFpAIm',
    name: 'flduWqZRoYDK1z8Ic',
    templates: 'fldt58GLs4lkD6xs1',
    campaign: 'fldqfsVoXXD8JSb5O',
    campaignTemplateVariables: 'fldvm001rtUNfpp8k',
  },
  schema: {
    recordId: 'string | null',
    name: 'string',
    templates: 'string[]',
    campaign: 'string[]',
    campaignTemplateVariables: 'string[]',
  },
};

export interface CampaignTemplateVariable extends Item {
  id: string,
  name: string | null,
  attribute: string[],
  campaignTemplate: string[],
  attributeKey: string | null,
  value: string,
}

export const campaignTemplateVariablesTable: Table<CampaignTemplateVariable> = {
  name: 'campaign_template_variables',
  baseId: 'apppFOPB68W0tWFuu',
  tableId: 'tblzBJ61fqHif7KqD',
  mappings: {
    name: 'fldEy6K1oIkxFdbWh',
    attribute: 'fldyyzN5izwkirFaG',
    campaignTemplate: 'fldbY4FZi7XNQWobo',
    attributeKey: 'fldsvjIcfoLSxevog',
    value: 'fld4TceuUDQtRhoEp',
  },
  schema: {
    name: 'string | null',
    attribute: 'string[]',
    campaignTemplate: 'string[]',
    attributeKey: 'string | null',
    value: 'string',
  },
};

export interface CampaignVariable extends Item {
  id: string,
  name: string | null,
  attribute: string[],
  campaign: string[],
  attributeKey: string | null,
  value: string,
}

export const campaignVariablesTable: Table<CampaignVariable> = {
  name: 'campaign_variables',
  baseId: 'apppFOPB68W0tWFuu',
  tableId: 'tbltGnk3UH9AMcTHm',
  mappings: {
    name: 'fldyDKY33ZMPcikd0',
    attribute: 'fldsDd17XQYCPwOrp',
    campaign: 'fld53IT1Xop5n1xs7',
    attributeKey: 'fldRR4IhcylX2SfwG',
    value: 'fldYYQswzUiLomxV8',
  },
  schema: {
    name: 'string | null',
    attribute: 'string[]',
    campaign: 'string[]',
    attributeKey: 'string | null',
    value: 'string',
  },
};

export interface Po extends Item {
  id: string,
  name: string,
  templates: string[],
}

export const posTable: Table<Po> = {
  name: 'pos',
  baseId: 'apppFOPB68W0tWFuu',
  tableId: 'tblvRmgxjrQ59JHqH',
  mappings: {
    name: 'fld1w85zhGzTWFLrQ',
    templates: 'fldYkCWVbbycTW38U',
  },
  schema: {
    name: 'string',
    templates: 'string[]',
  },
};

export interface Template extends Item {
  id: string,
  name: string,
  description: string,
  pos: string[],
  components: string[],
  preview: string,
  campaignTemplates: string[],
  recordId: string | null,
  width: number,
  height: number,
  isPreview: boolean,
}

export const templatesTable: Table<Template> = {
  name: 'templates',
  baseId: 'apppFOPB68W0tWFuu',
  tableId: 'tblFx7zmQ5zvB1EN3',
  mappings: {
    name: 'fldHD4sbkQ4NjP9Sy',
    description: 'fldPd1Eal8D19MD19',
    pos: 'fld2glskBTSpcVJYH',
    components: 'fldyyFHk6M1pvsQk4',
    preview: 'fldwmEZpqLuiTeDhp',
    campaignTemplates: 'fldgu2nWmKI3EAxUE',
    recordId: 'fldkXr3Frx6R9fUbV',
    width: 'fldRAVNnadTjhIPBJ',
    height: 'fldPOviu6oOftkT8o',
    isPreview: 'fldAOc0c50kfiuZLf',
  },
  schema: {
    name: 'string',
    description: 'string',
    pos: 'string[]',
    components: 'string[]',
    preview: 'string',
    campaignTemplates: 'string[]',
    recordId: 'string | null',
    width: 'number',
    height: 'number',
    isPreview: 'boolean',
  },
};

export interface Component extends Item {
  id: string,
  key: string | null,
  template: string[],
  name: string,
  description: string,
  options: string,
  componentAttributes: string[],
}

export const componentsTable: Table<Component> = {
  name: 'components',
  baseId: 'apppFOPB68W0tWFuu',
  tableId: 'tbluaeTswiq32jJgo',
  mappings: {
    key: 'fldBSxHpEUwkOgwyX',
    template: 'fldrAa5WZYybRoe8z',
    name: 'fldlU2LprY1bZXZFl',
    description: 'fldQTT1OZgN1GOsIo',
    options: 'fldv9eVsnhDaoL3gz',
    componentAttributes: 'fldaCt5duprig4oHT',
  },
  schema: {
    key: 'string | null',
    template: 'string[]',
    name: 'string',
    description: 'string',
    options: 'string',
    componentAttributes: 'string[]',
  },
};

export interface ComponentAttribute extends Item {
  id: string,
  key: string | null,
  component: string[],
  componentsPosition: string | null,
  status: string,
  attribute: string[],
  attributeType: string | null,
  options: string,
}

export const componentAttributesTable: Table<ComponentAttribute> = {
  name: 'component_attributes',
  baseId: 'apppFOPB68W0tWFuu',
  tableId: 'tblBwnUAOwTtI0Wya',
  mappings: {
    key: 'fldBcKdEraFmFH8Z8',
    component: 'fld9sZmTywtfeYsbd',
    componentsPosition: 'fldp7E5p2Nf0fswD8',
    status: 'fldV082MbvUfsjqt3',
    attribute: 'fldGulVY5V79Q7yux',
    attributeType: 'fldfBhwtXHvkylfFO',
    options: 'fldleb3sCbHGqaomW',
  },
  schema: {
    key: 'string | null',
    component: 'string[]',
    componentsPosition: 'string | null',
    status: 'string',
    attribute: 'string[]',
    attributeType: 'string | null',
    options: 'string',
  },
};

export interface Attribute extends Item {
  id: string,
  key: string | null,
  name: string,
  title: string,
  label: string,
  defaultValue: string,
  type: string,
  campaignTemplateVariables: string[],
  campaignVariables: string[],
  componentAttributes: string[],
  components: string[] | null,
}

export const attributesTable: Table<Attribute> = {
  name: 'attributes',
  baseId: 'apppFOPB68W0tWFuu',
  tableId: 'tblhqIDAnvseHxNXS',
  mappings: {
    key: 'fldgOHUsKinRTH0V8',
    name: 'fldlwNVjaNFZaVf0k',
    title: 'fldnjPJkxlretcLmh',
    label: 'fldH4mlxe5Cod9wPi',
    defaultValue: 'fldZnlOJmaM1ZJDB5',
    type: 'fldSTWjDD1hbFpqoq',
    campaignTemplateVariables: 'fldj0xOen8sRkxqI5',
    campaignVariables: 'fldd5b2g2pU9RCzZO',
    componentAttributes: 'fldWXICMsz3K4lKTi',
    components: 'fldSTMfwmKffHc41s',
  },
  schema: {
    key: 'string | null',
    name: 'string',
    title: 'string',
    label: 'string',
    defaultValue: 'string',
    type: 'string',
    campaignTemplateVariables: 'string[]',
    campaignVariables: 'string[]',
    componentAttributes: 'string[]',
    components: 'string[] | null',
  },
};